import React from "react";
import { Route, Redirect } from "react-router-dom";

import Authenticated from "./Authenticated";
import LoaderModule from "../Components/Loader";

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      return (
        <Authenticated
          renderTrue={(user) => <Component user={user} {...props} />}
          renderPending={() => <LoaderModule />}
          renderFalse={() => (
            <Redirect
              to={{
                pathname: "/login",
                state: {
                  from: props.location,
                  message: "You must be logged to access this space !"
                }
              }}
            />
          )}
        />
      );
    }}
  />
);

export default PrivateRoute;
